






























































import CreatModal from './CreatModal.vue'
import EditModal from './EditModal.vue'
import { StockOutPlanServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'
import dayjs from 'dayjs'
import Vue from 'vue'
const sopsp = new StockOutPlanServiceProxy()
const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 100,
    scopedSlots: { customRender: 'actions' }
  },
  {
    title: 'page_job_make_delivery_delivery_plan_no',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: 'page_job_make_delivery_planned_delivery_time',
    dataIndex: 'planStockOutTime',
    key: 'planStockOutTime',
    customRender: (text) => {
      if (text) {
        return dayjs(text).format('YYYY-MM-DD')
      }
    }
  },
  {
    title: 'page_job_make_delivery_production_no',
    dataIndex: 'planCode',
    key: 'planCode'
  },
  {
    title: 'page_job_make_delivery_product_code',
    key: 'productCode',
    dataIndex: 'productCode'
  },
  {
    title: 'page_job_make_delivery_product_name',
    dataIndex: 'productName',
    key: 'productName'
  },
  {
    title: 'page_job_make_delivery_specification_model',
    dataIndex: 'standardModel',
    key: 'standardModel'
  },
  {
    title: 'page_job_make_delivery_scheduled_start_time',
    dataIndex: 'planStartTime',
    key: 'planStartTime',
    customRender: (text) => {
      if (text) {
        return dayjs(text).format('YYYY-MM-DD')
      }
    }
  },
  {
    title: 'page_resource_pool_status',
    key: 'planStatus',
    dataIndex: 'planStatus',
    scopedSlots: { customRender: 'planStatus' }
  }
]
export default Vue.extend({
  components: {
    CreatModal,
    EditModal
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  props: {
    source: {
      type: Number,
      default: 0
    }
  },
  watch: {
    source: {
      handler() {
        this.changeScroll()
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      dataSource: [], // 表单数据
      pagination: {
        current: 1,
        keyWords: '',
        size: 10,
        total: 0
      },
      editdata: {}, // 编辑项内容
      selectedRowKeys: [], // 选中内容,
      creatVisible: false,
      editVisible: false,
      scrollY: 0
    }
  },
  created() {
    this.getTableData()
  },
  methods: {
    checkSatatus(text) {
      let value = ''
      if (text) {
        switch (Number(text)) {
          case 1:
            value = this.$t('page_material_delivery_plan_be_delivered')
            break
          case 2:
            value = this.$t('page_material_delivery_plan_hang_air')
            break
          case 3:
            value = this.$t('page_material_delivery_plan_completed')
            break
          default:
            break
        }
      }
      return value
    },
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(value) {
      this.pagination.current = value
      this.getTableData()
    },
    async getTableData() {
      this.dataSource = []
      const res = await sopsp.pageStockOutPlan(
        this.pagination.current,
        this.pagination.keyWords,
        this.pagination.size
      )
      this.pagination.total = res.total
      if (res.total) {
        this.dataSource = res.records
        const aad = res.records.find((res) => res.id === this.editdata.id)
        if (!aad) {
          this.selectedRowKeys = [res.records[0].id]
          this.editdata = res.records[0]
          this.$emit('select', this.editdata)
        } else {
          this.$emit('bot')
        }
        this.changeScroll()
      } else {
        this.selectedRowKeys = []
        this.editdata = []
      }
    },
    changeScroll() {
      const dev = document.getElementById('top-body')
      if (dev && (dev.clientHeight - 102) < this.dataSource.length * 32) {
        this.scrollY = dev.clientHeight - 102
      } else {
        this.scrollY = 0
      }
    },
    creat() {
      this.creatVisible = true
    },
    async deleteItem() {
      await sopsp.deleteStockOutPlan(this.selectedRowKeys)
      this.search('')
    },
    search(value) {
      setTimeout(() => {
        this.pagination.current = 1
        this.pagination.keyWords = value
        this.getTableData()
      }, 50)
    },
    closeCreat() {
      this.creatVisible = false
      this.search('')
    },
    closeEdit() {
      this.editVisible = false
      this.search('')
    },
    onEdit(value) {
      this.editVisible = true
      this.editdata = value
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys
    },
    // 表格行点击事件
    rowClick(record: any) {
      return {
        on: {
          click: () => {
            this.selectedRowKeys = [record.id]
            this.editdata = record
            this.$emit('select', this.editdata)
          }
        }
      }
    }
  }
})
